// extracted by mini-css-extract-plugin
export var textInput = "_ga-0";